import { useForecastContext } from '../../contexts/ForecastContextProvider';

// SkySight-style segmented control. Active pill = solid blue, white bold text.
// Inactive pill = transparent, takes the surrounding text color. Both pills sit
// inside a single rounded container with a thin border for visual cohesion.
const ModelPicker = () => {
    const { model, setModel } = useForecastContext();
    const base = 'flex-1 text-center text-sm font-medium px-3 py-1.5 rounded-full cursor-pointer transition-colors';
    const active = 'bg-blue-500 text-white font-bold';
    const inactive = 'text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-700';
    return (
        <div className="inline-flex items-center gap-1 p-1 rounded-full bg-slate-100 dark:bg-slate-900 ring-1 ring-slate-200 dark:ring-slate-700">
            <span
                className={`${base} ${model === 'EUROPE' ? active : inactive}`}
                onClick={() => setModel('EUROPE')}
            >
                EU
            </span>
            <span
                className={`${base} ${model === 'ICON' ? active : inactive}`}
                onClick={() => setModel('ICON')}
            >
                ICON
            </span>
        </div>
    );
};

export default ModelPicker;
